import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'pcg-device-events-modal'
    , templateUrl: './device-events-modal.component.html'
    , styleUrl: './device-events-modal.component.scss'
    , standalone: false
})
export class DeviceEventsModalComponent {

    knoxEvents!: [];
    constructor(public activeModal: NgbActiveModal) { }    
    closeModal() { this.activeModal.close(); }
}